
const digest = '96cf8aed62ec8c7ff135d314a8dde2386dbcc6775a7276910784736fae1b6e2f';
const classes = {"item":"_item_1m5qn_1","icon":"_icon_1m5qn_1"};
const css = `._item_1m5qn_1 ._icon_1m5qn_1 {
  height: 25px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  